export default __webpack_public_path__ + "static/questions-f6818e16e5df0b0a3882dab5535c5d9f.png";